<template>
  <generic-modal :title="$t('document')" ref="generic_modal" :is_wide="true">
    <div class="form">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('categories')"
              :is_multiple="true"
              :placeholder="$t('select one')"
              url="/patient/catalog"
              name_field="name"
              value_field="category_id"
              @selected="set_categories"
              ref="categories_dropdown"
              :add_new="false"
            />
          </div>
        </div>
      </div>

      <div class="container">
        <div class="field">
          <div class="control">
            <generic-uploader
              ref="generic_uploader"
              :idle_label="$t('drop photos here')"
              endpoint_url="/patient/document/photo"
              :extra_data="{ patient_uuid: $route.params.patient_uuid }"
              @error="error_uploading"
              @success="success_uploading"
              :allow_multiple="true"
            />
          </div>
        </div>

        <div
          class="grid is-col-min-7"
          v-if="meta.settings && meta.settings.photos"
        >
          <div
            class="cell"
            v-for="(photo, midx) in meta.settings.photos"
            :key="midx"
          >
            <div class="card">
              <div class="card-image">
                <figure class="image is-128x128 m-auto py-3">
                  <v-lazy-image
                    v-if="
                      photo.mimetype.includes(
                        'image',
                        'application/octet-stream'
                      )
                    "
                    :src="`${api_host}/drive/static/${photo.final_name}`"
                  />
                  <img
                    v-else-if="
                      photo.mimetype.includes(
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                      )
                    "
                    src="https://cdn-icons-png.flaticon.com/512/17018/17018393.png"
                  />
                  <img
                    v-else-if="photo.mimetype.includes('application/pdf')"
                    src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <!-- <p class="subtitle is-7 has-text-centered">
                  {{ photo.file }}
                </p> -->
                    <p class="subtitle is-6 has-text-centered mb-0">
                      {{ photo.description }}
                    </p>
                    <p class="subtitle is-7 has-text-centered">
                      {{ photo.mimetype }}
                    </p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div
                  class="button is-secondary card-footer-item"
                  @click="remove_photo(photo, midx)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
                <div
                  class="button is-secondary card-footer-item"
                  @click="describe_photo(photo)"
                  :data-tooltip="$t('describe')"
                >
                  <span class="icon">
                    <i class="fa fa-edit"></i>
                  </span>
                </div>
                <div
                  class="button is-secondary card-footer-item"
                  @click="download_photo(photo)"
                  :data-tooltip="$t('download')"
                >
                  <span class="icon">
                    <i class="fa fa-download"></i>
                  </span>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
    <patient-modal ref="patient_modal" />
    <team-modal ref="team_modal" />
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  get,
  post,
  error_alert,
  download,
  generate_error_message_text,
  get_currency_settings,
  api_host,
  input_alert,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import VLazyImage from "v-lazy-image";
import PatientModal from "../../../patient_datatable/patient_modal/Index.vue";
import TeamModal from "../../../team_datatable/team_modal/Index.vue";

export default {
  name: "DocumentModal",
  components: {
    GenericModal,
    GenericCalendar,
    GenericDropdown,
    PatientModal,
    TeamModal,
    GenericUploader,
    VLazyImage,
  },
  data() {
    return {
      api_host,
      meta: { settings: {}, photos: [], medical_service_uuid: "" },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.patient_id || !v.meta.start_date;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(medical_service_uuid) {
      let v = this;
      v.set_initial_state();
      v.meta.medical_service_uuid = medical_service_uuid;
      v.$refs.generic_modal.show_modal();
    },
    edit(document_uuid) {
      let v = this;
      v.set_initial_state();

      get("/patient/document", { uuid: document_uuid })
        .then((document) => {
          v.meta = document;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
          v.$refs.generic_modal.show_modal();
        });
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      data.patient_uuid = v.$route.params.patient_uuid;
      if (!v.meta.uuid)
        put("/patient/patient-medical-service/document", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/patient/document", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        categories: [],
        settings: {},
      };
      v.error = "";
      v.$refs.categories_dropdown.clear();
      v.$refs.generic_uploader.clear();
      // v.uuid = "";
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete document?"),
        v,
        () => {
          del("/patient/document", { uuid: v.meta.uuid })
            .then(() => {
              v.$emit("success");
              v.$refs.generic_modal.close_modal();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      // console.log("success_uploading", response);
      let v = this;
      let obj = JSON.parse(response.serverId);
      if (v.meta.settings.photos) v.meta.settings.photos.push(obj);
      else v.meta.settings.photos = [obj];
      // let v = this;
      // v.$refs.generic_uploader.clear();
      // v.init();
    },
    remove_photo(photo, index) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete photo?"), v, () => {
        del("/patient/document/photo", { id: photo.file.file.file_id })
          .then(() => {
            v.meta.settings.photos.splice(index, 1);
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      });
    },
    describe_photo(photo) {
      let v = this;
      let options = {
        input: "textarea",
        title: v.$t("describe photo"),
        input_value: photo.description,
        placeholder: v.$t("description"),
        confirm_text: v.$t("save"),
        cancel_text: v.$t("cancel"),
      };
      input_alert(options).then((value) => {
        photo.description = value;
      });
    },
    set_categories(categories) {
      let v = this;
      if (categories) v.meta.categories = categories.map((c) => c.patient_id);
    },
    download_photo(photo) {
      let v = this;
      let file_path = `${api_host}/drive/static/${photo.final_name}`;
      // download(file_path, photo.file_name);
      window.open(file_path, "_blank");
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
